import { render, staticRenderFns } from "./Zyrk.vue?vue&type=template&id=c4a3bbd4&scoped=true&"
import script from "./Zyrk.vue?vue&type=script&lang=js&"
export * from "./Zyrk.vue?vue&type=script&lang=js&"
import style0 from "./Zyrk.vue?vue&type=style&index=0&id=c4a3bbd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a3bbd4",
  null
  
)

export default component.exports